import { Search } from '@mui/icons-material'
import { IconButton, Input } from '@mui/material'
import React from 'react'

const MainSearch = () => {
  return (
    <div className='w-full rounded-[15px] flex 3xl:rounded-lg overflow-hidden  bg-goldenYellow'>
        <div  className='h-[62px] desktop:!h-[45px] desktop:px-[10px] 3xl:h-[55px]  px-6 w-[90%] miniDesk:px-[10px] flex items-center gap-x-4 bg-white'>
            <Search  className='text-Charcoal-1 desktop:text-[20px]'/>
            <Input classes={{
                input : "w-full  !border-none !outline-none !placeholder:text-black"
            }} className='h-[62px] desktop:text-[12px] before:!border-none after:!border-none w-full !border-none    bg-white' placeholder="Search Colleges, Courses, Exams" />
        </div>
        <IconButton className='w-[10%] min-w-[70px]'>
            <Search  className='text-black desktop:text-[20px] text'/>
        </IconButton>
    </div>
  )
}

export default MainSearch